import React, { useState, useEffect } from "react";
import Translations from '../../../services/translation.service';
import Storage from "../../../services/storage.service";
import CONSTANTS from "../../../services/constants.service";
import Helpers from "../../../helpers/shared.helper";
import BillPaymentService from "../../../services/bill-payment.service";
import moment from 'moment';
import "moment/locale/ar-sa";
import "moment/locale/en-ca";
import { saveAs } from 'file-saver';
import FirebaseAnalytics from "../../../services/analytics.service";
import BillOpenIcon from "../../../assets/img/BillOpenIcon.svg";
import BillClosedIcon from "../../../assets/img/BillClosed.svg";
import ChangePlanArrow from "../../../assets/img/ChangePlanArrow.svg";
import QuestionCircleIcon from "../../../assets/img/QuestionCircle.svg";
import ZigZag from "../../../assets/img/Bottomzigzag.svg";
import SpinnerTimeLoader from "../../shared/timeLoading";
import storefront from "../../../services/storefront.service";
import ModalWrapper from "../../shared/modal-wrapper";
import ContentSlider from "../../shared/contentSlider";

const subscriptions = [];
const BillInvoice = (props) => {
    // const { history } = props;
    const [subLoading, setSubLoading] = useState(false);
    const [invoice, setInvoice] = useState({});
    // const [mappedTotalDueAmount, setMappedTotalDueAmount] = useState({});
    const [mappedPendingInvoiceDetails, setMappedPendingInvoiceDetails] = useState({});
    const [expandedInvoice, setExpandedInvoice] = useState(props.viewedInvoice);
    const [subExpandedInvoice, setSubExpandedInvoice] = useState(props.viewedInvoice);
    // const [invoiceDetails, setInvoiceDetails] = useState({});
    const [allPlans, setAllPlans] = useState(null);
    const isHBB = props?.numberType === "postpaid" ? false : true;
    const [openModal, setOpenModal] = useState(false);
    const [infoModalDetails, setInfoModalDetails] = useState({
      imagesFolder: "",
      sliderData: [],
    });

    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []);

    const handleModal = (e) => {
      e.stopPropagation();
      setOpenModal((prev) => !prev);
    };
  

  const handleModalData = (e, type) => {
    if(type === "about_optima_popup_json"){
      const firebase_event_params = {
        event_category: 'bills',
        event_screen: 'bills_details',
        interaction_type: 'click',
        event_label: 'optima_info'
      }
      FirebaseAnalytics.commonFunction(firebase_event_params);
    }else if(type === "received_payments_popup_json"){
      const firebase_event_params = {
        event_category: 'bills',
        event_screen: 'bills_details',
        interaction_type: 'click',
        event_label: 'recieved_payment_info'
      }
      FirebaseAnalytics.commonFunction(firebase_event_params);
    }else if(type === "previous_balance_popup_json"){
      const firebase_event_params = {
        event_category: 'bills',
        event_screen: 'bills_details',
        interaction_type: 'click',
        event_label: 'previous_balance_info'
      }
      FirebaseAnalytics.commonFunction(firebase_event_params);
    }
    const sliderData = getSliderData(type);
    if (sliderData) {
      setInfoModalDetails({
        "imagesFolder": "information_popup_images",
        "sliderData": sliderData
      });
      handleModal(e)
    }
  };

    const getSliderData = (modalKey) => {
      const poModalKey = modalKey;
      let business = Storage.get("business", true);
      let poModalData = null;
      if (business) {
        business = JSON.parse(business);
        if (business[poModalKey]) {
          poModalData = business[poModalKey]
        }
      }
      return poModalData
    }
  const getVatPercentage = () => {
    let vat_percentage = JSON.parse(Storage.get("business", true))[
      "vat_percentage"
    ];
    return vat_percentage || 0
  }

  const DateToMonth = (date) => {
    // Convert the date to the full month name
    const month = moment(date).format('MMMM');
    return month;
  };

  const getFinalPrice = (data) => {
    if(data?.PlanCardDiscountedPrice < data?.PlanCardPrice)
    { 
      return Helpers.formatWithPORemoveCommas(data?.PlanCardDiscountedPrice)
    } else {
      return Helpers.formatWithPORemoveCommas(data?.PlanCardPrice)
    }
  }

  const getPlanData = (data) => {
    let planData = Helpers.filterByPlanType(data?.Plan, "DATA");
    let dataVal = 0;
    if(planData?.length) {
      dataVal = storefront.getTransformedPlanTypeValues(planData[0]?.Value, planData[0]?.Unit)
    }
    return dataVal === -1 ? Translations.keys["free_addons_unlimited"] : dataVal
  }

  const getPlanImage = (data) => {
    if(data?.PlanCode) {
      return Helpers.getPOImageCommon("stf_predefined_img_for_mobile", data?.PlanCode.toLowerCase(), Translations.activeLang, "")
    }
    return ""
  }
  
  const renderChangePlanMob = (pplCode = "", invoiceDtl) => {
    let content = "";
    if(allPlans) {
      let changePlanCode = pplCode;
      let currentPlanCode = invoice?.PricePlanCode;
      let filteredChangePlan = allPlans?.filter(plan => plan.PlanCode === changePlanCode)?.[0];
      let filteredCurrentPlan = allPlans?.filter(plan => plan.PlanCode === currentPlanCode)?.[0];

      let currentPlan = (
      <div style={{backgroundImage: `url("${getPlanImage(filteredCurrentPlan)}")`}}>
        <div className="sim-bill-payment-details">
          <div>{translationKeys["stm_bill_payment_choosen_plan"]}</div>
          <div>
            <span>
              {getPlanData(filteredCurrentPlan)}{" "}{translationKeys["stm_general_data_unit"]}
            </span>
            <span>
              {getFinalPrice(filteredCurrentPlan)}{" "}{translationKeys["stm_general_currency"]}
            </span>
          </div>
        </div>
      </div>
      );

      if (pplCode === null || pplCode === '' || pplCode === undefined) {
        content = (<>
          <span>{`${translationKeys["stm_switch_description_same_plan"]} ${invoice?.FromDate && DateToMonth(invoice.FromDate)}!`}</span>
          <div className="sim-bill-payment-plans single-sim-bill-payment-plan">
            {currentPlan}
          </div>
        </>);
      } else {
        content = (
        <>
          <span>{`${translationKeys["stm_switch_description_lower_plan"]} ${invoice?.FromDate && DateToMonth(invoice.FromDate)}! ${translationKeys["stm_switch_description_saved"]} ${invoice.OptimaSavings} ${translationKeys["stm_general_currency"]}`}</span>
          <div className="sim-bill-payment-plans">
            {currentPlan}
            <div style={{backgroundImage: `url("${getPlanImage(filteredChangePlan)}")`}}>
              <div className="sim-bill-payment-details">
                <div>{translationKeys["stm_bill_payment_best_plan"]}</div>
                <div>
                  <span>
                    {getPlanData(filteredChangePlan)}{" "}{translationKeys["stm_general_data_unit"]}
                  </span>
                  <span>
                    {getFinalPrice(filteredChangePlan)}{" "}{translationKeys["stm_general_currency"]}
                  </span>
                </div>
              </div>
            </div>
            <img src={ChangePlanArrow} alt="" />
          </div>
        </>);
      }
    }
    return content;
  }

  const renderChangePlan = (pplCode = "", invoiceDtl) => {
    let content = "";
    if(allPlans) {
      let changePlanCode = pplCode;
      let currentPlanCode = invoice?.PricePlanCode;
      let filteredChangePlan = allPlans?.filter(plan => plan.PlanCode === changePlanCode)?.[0];
      let filteredCurrentPlan = allPlans?.filter(plan => plan.PlanCode === currentPlanCode)?.[0];

      let currentPlan = (
      <div>
        <img src={getPlanImage(filteredCurrentPlan)} alt="" className="change-plan-img"/>
        <div className="sim-bill-payment-details-fi">
          <div>{translationKeys["stm_bill_payment_choosen_plan"]}</div>
          <div>
            <span>
              {getPlanData(filteredCurrentPlan)}{" "}{translationKeys["stm_general_data_unit"]}
            </span>
            <span>
              {getFinalPrice(filteredCurrentPlan)}{" "}{translationKeys["stm_general_currency"]}
            </span>
          </div>
        </div>
      </div>
      );

      if (pplCode === null || pplCode === '' || pplCode === undefined) {
        content = (<>
          <span>{`${translationKeys["stm_switch_description_same_plan"]} ${invoice?.FromDate && DateToMonth(invoice.FromDate)}!`}</span>
          <div className="sim-bill-payment-plans-fi single-sim-bill-payment-plan-fi">
            {currentPlan}
          </div>
        </>);
      } else {
        content = (
        <>
          <span>{`${translationKeys["stm_switch_description_lower_plan"]} ${invoice?.FromDate && DateToMonth(invoice.FromDate)}! ${translationKeys["stm_switch_description_saved"]} ${invoice.OptimaSavings} ${translationKeys["stm_general_currency"]}`}</span>
          <div className="sim-bill-payment-plans-fi">
            {currentPlan}
            <div>
              <img src={getPlanImage(filteredChangePlan)} alt="" className="change-plan-img"/>
              <div className="sim-bill-payment-details-fi">
                <div>{translationKeys["stm_bill_payment_best_plan"]}</div>
                <div>
                  <span>
                    {getPlanData(filteredChangePlan)}{" "}{translationKeys["stm_general_data_unit"]}
                  </span>
                  <span>
                    {getFinalPrice(filteredChangePlan)}{" "}{translationKeys["stm_general_currency"]}
                  </span>
                </div>
              </div>
            </div>
            <img src={ChangePlanArrow} alt="" className="arrow-img"/>
          </div>
        </>);
      }
    }
    return content;
  }
    const getConvertedBillDate = (dateStringStart, dateStringEnd, lang) => {  
      if (Translations.activeLang === "en") {
        moment.locale("en-ca");
      }
      if (Translations.activeLang === "ar") {
        moment.locale("ar-sa");
      }
      const start = moment(dateStringStart);
      const end = moment(dateStringEnd);
      const formattedStart = start.format('DD MMM');
      const formattedEnd = end.format('DD MMM YYYY');
      return `${formattedStart} - ${formattedEnd}`
    }

    const downloadBill = (invoice, index) => {
      const invoice_number = invoice?.InvoiceNo
      let firebase_param = {
        bill_number: invoice_number,
      }
      FirebaseAnalytics.download_bill(firebase_param);
      const firebase_event_params = {
        event_category: 'bills',
        event_screen: 'bills_details',
        interaction_type: 'click',
        event_label: 'download',
        bill_cycle: trimDate(invoice?.FromDate) + " - " + trimDate(invoice?.ToDate),
        due_amount: invoice?.TotalDueAmount || '',
        index: index
      }
      FirebaseAnalytics.commonFunction(firebase_event_params);
      BillPaymentService.billDownloadByInvoice(invoice_number)
      .then((res) => {
        saveAs(res.data, `invoice_${invoice_number}.pdf`);
      })
      .catch((res) => {
        // Do nothing
      })
    }

    const trimDate = (date) => {
      return date?.split("T")[0] || "";
    }

    const fetchPlans = (number) => {
      // Fetch the details for Current & Change Plan
      let currentProductCode = Helpers.checkForProductDetail("name", CONSTANTS.REGULAR_POSTPAID_PRODUCT_ATTR);
      BillPaymentService.getAllPlans(currentProductCode?.code, number)
      .then((res) => {
        if(res.data.PreDefinedBundles) {
          setSubLoading(false);
          const filteredPlansData = res.data.PreDefinedBundles?.filter(bundle => String(bundle.ProductCode) === String(currentProductCode?.code));
          const allPlans = filteredPlansData[0].PreDefinedBundle;
          setAllPlans(allPlans);
          // processBillList(number, billInvoiceDetails);
        }
      })
      .catch((res) => {
        // Do nothing
        setSubLoading(false)
      })
    }


      const handleToggle = async (recentInvoice, index) => {
        const recentInvoiceNumber = recentInvoice?.InvoiceNo;
    
        // setSubLoading(true);
        // const firebase_event_params = {
        //   event_category: 'bills',
        //   event_screen: 'bills_details',
        //   interaction_type: 'click',
        //   event_label: 'expand',
        //   bill_cycle: trimDate(recentInvoice?.FromDate) + " - " + trimDate(recentInvoice?.ToDate),
        //   due_amount: recentInvoice?.TotalDueAmount || "",
        //   index: index,
        //   is_expanded: expandedInvoice === recentInvoiceNumber
        // }
        // FirebaseAnalytics.commonFunction(firebase_event_params);
        if (expandedInvoice === recentInvoiceNumber) {
            setExpandedInvoice(null);
        } else {
            setExpandedInvoice(recentInvoiceNumber);
            // Call API to fetch invoice details
            // fetchPlans(props.msisdn)
            // BillPaymentService.billByInvoice(recentInvoiceNumber)
            // .then((response) => {
            //   if (response) {
            //     setSubLoading(false)
            //     let data = response.data;
            //     if(data && data?.PendingInvoiceDetails?.length) {
            //       let invoicedata = data.PendingInvoiceDetails[0];
            //       setInvoiceDetails(invoicedata);
            //     }
            //   }
            // })
            // .catch(() => {
            //   setSubLoading(false)
            // })
        }
      };

      useEffect(() => {
        if(props.viewedInvoice) {
            props.invoiceStatusState("loading");
            fetchInvoiceDetail(props.viewedInvoice);
        }
      }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const fetchInvoiceDetail = (invoiceNumber) => {
      // const invoiceNumbers = props.viewedInvoice;
      BillPaymentService.billByInvoice(invoiceNumber)
      .then((response) => {
        if (response) {
            props.invoiceStatusState("success");
            // Mapping TotalDueAmount with InvoiceNo
          if(response.data.PendingInvoiceDetails) {
            setInvoice(response.data.PendingInvoiceDetails[0]);
            setSubLoading(true);
            fetchPlans(props.msisdn);
            // handleToggle(response.data.PendingInvoiceDetails[0], 1)
            // setSubExpandedInvoice(response.data.PendingInvoiceDetails[0]);
            let responseData = response.data.PendingInvoiceDetails;
            // const getMostRecentInvoice = responseData[responseData.length - 1];
            // let amountToBePaid = getMostRecentInvoice?.TotalDueAmount;
            // const mappedTotalDueAmounts = responseData.reduce((accumulator, invoice) => {
            //   accumulator[invoice.InvoiceNo] = {
            //     TotalDueAmount: invoice.TotalDueAmount
            //   };
            //   return accumulator;
            // }, {});
            // setMappedTotalDueAmount(mappedTotalDueAmounts);
            const mappedPendingInvoiceDetails = responseData.reduce((accumulator, invoice) => {
              accumulator[invoice.InvoiceNo] = invoice; // Store the entire invoice object
              return accumulator;
            }, {});
            setMappedPendingInvoiceDetails(mappedPendingInvoiceDetails);
            // setLoading(false);
          } else {
            // setLoading(false);  
          }
        } else {
            props.invoiceStatusState("failed");
        }
      })
      .catch(() => {
        // setSubLoading(false)
        props.invoiceStatusState("failed");
      })
    }

    let billContent = <div className="stf-deactivation-bill-wrapper stf-bill-payment-wrapper-msisdn">
      <div className="sim-deactivation-bill-container">
        {props.viewedInvoice && invoice ?
          <>
              <div className={`sim-deactivation-bill ${Helpers.isSafari() ? "safari" : ""}`} key={invoice?.InvoiceNo}>
              <div className="sim-deactivation-bill-content">
                <div className="sim-deactivation-bill-header">
                  <div>
                      <div>{translationKeys["stm_bill_payment_bill"]}{" "}#{invoice?.InvoiceNo}</div>
                      <span>{mappedPendingInvoiceDetails[invoice.InvoiceNo]?.FromDate && mappedPendingInvoiceDetails[invoice.InvoiceNo]?.ToDate ? <>{getConvertedBillDate(mappedPendingInvoiceDetails[invoice.InvoiceNo]?.FromDate, mappedPendingInvoiceDetails[invoice.InvoiceNo]?.ToDate, Translations.activeLang)}</> : ""}</span>
                      {/* STARTS: Hide the below div if collapsable is Closed */}
                      {expandedInvoice === invoice.InvoiceNo ?
                      <div 
                        className="sim-deactivation-download-bill" 
                      >
                        <button 
                          onClick={() => {
                            downloadBill(invoice, 1)
                          }}
                        >
                          {translationKeys["stm_bill_payment_download_bill"]}
                        </button>
                      </div> : ""}
                      {/* ENDS: Hide the below div if collapsable is Closed */}

                  </div>
                  <div className="bill-status-container">
                    <div className="bill-status">
                      {translationKeys["stm_bill_payment_unpaid"]}
                    </div>
                    <img src={expandedInvoice === invoice.InvoiceNo ? BillOpenIcon : BillClosedIcon} alt="" onClick={() => handleToggle(invoice, 1)}/>
                  </div>                    
                </div>

                <hr />

                {/* Collapsable Section Main Starts Here */}
                {expandedInvoice === invoice.InvoiceNo ?
                <div
                  className="sim-deactivation-bill-details" 
                >
                  {subLoading ?
                  <SpinnerTimeLoader /> :
                  <>
                    {(!isHBB && invoice.PricePlanCode !== "HBB") && (<>
                    {Helpers.isMobile600() ?
                      <div className="sim-bill-payment-change-plan">
                        {invoice && renderChangePlanMob(invoice?.OptimaPplCode, invoice)}
                      </div> : 
                      <div className="sim-bill-payment-change-plan-fi">
                        {invoice && renderChangePlan(invoice?.OptimaPplCode, invoice)}
                      </div>
                    }
                    <hr />
                    </>)}
                    <div className="sim-deactivation-bill-summary">
                      <div className="sim-deactivation-bill-info-header">
                        <div>{translationKeys["stm_bill_payment_plans"]}</div>
                        <div>{translationKeys["stm_bill_payment_subtotal"]}</div>
                      </div>
                      <div className="sim-deactivation-bill-info">
                        <div>{translationKeys[`general_plan_name_${Helpers.processLokaliseKey(invoice.PricePlanCode)}`]}</div>
                        <div>{Helpers.formatWithPORemoveCommas(invoice.MonthlySubFees)}{" "}{translationKeys["stm_general_currency"]}</div>
                      </div>
                      {mappedPendingInvoiceDetails[invoice.InvoiceNo]?.OutOfBundleUsage?.length > 0 ? 
                        mappedPendingInvoiceDetails[invoice.InvoiceNo]?.OutOfBundleUsage?.map((item, index) => {
                          return <div className="sim-deactivation-bill-info" key={index}>
                            <div>{item?.Type}</div>
                            <div>{Helpers.formatWithPORemoveCommas(item.UsageBasedSubFees)}{" "}{translationKeys["stm_general_currency"]}</div>
                          </div>
                        })
                      : null}
                    </div>
                    <hr />
                    <div className="sim-pay-bill-see-details">
                      <div className="sim-pay-bill-see-details-header">
                        <span>{translationKeys["stm_bill_payment_see_bill_details"]}</span>
                        <img src={subExpandedInvoice === invoice.InvoiceNo ? BillOpenIcon : BillClosedIcon} alt="" onClick={() => {
                          if (subExpandedInvoice === invoice.InvoiceNo) {
                            setSubExpandedInvoice(null);
                          } else {
                            setSubExpandedInvoice(invoice.InvoiceNo);
                          }
                        }}/>
                      </div>
                      {subExpandedInvoice === invoice.InvoiceNo ?
                      <div className="sim-pay-bill-see-details-content">
                        <div className="sim-pay-bill-see-details-content-row">
                          <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_total_month_charges"]}{" "}<span>{translationKeys["stm_bill_payment_vat_excl"]}</span></div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.TotalMonthlyCharges)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>

                        {(!isHBB && invoice.PricePlanCode !== "HBB") &&
                        <div className="sim-pay-bill-see-details-content-row optima-savings">
                          <div className="sim-pay-bill-see-details-content-row-text-icon">
                            <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_optima_savings"]}</div> 
                            <img 
                              src={QuestionCircleIcon} alt="" 
                              onClick={(e) => {
                                handleModalData(e, "about_optima_popup_json")}
                              }
                            />
                          </div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.OptimaSavings)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>}

                        {invoice?.MonthlySavings ?
                        <div className="sim-pay-bill-see-details-content-row monthly-savings">
                          <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_monthly_savings_amount"]}</div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.MonthlySavings)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div> : ""}

                        {/* {isHBB && Helpers.formatWithPORemoveCommas(invoiceDetails?.OptimaSavings) > 0 &&
                        <div className="sim-pay-bill-see-details-content-row optima-savings">
                          <div className="sim-pay-bill-see-details-content-row-text-icon">
                            <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_discount"] || "Discount"}</div>
                          </div>
                          <div>{Helpers.formatWithPORemoveCommas(invoiceDetails?.OptimaSavings)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>} */}

                        {(isHBB || invoice.PricePlanCode === "HBB") && Helpers.formatWithPORemoveCommas(invoice?.RemainingCommitmentAmount) > 0 &&
                        <div className="sim-pay-bill-see-details-content-row">
                          <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_termination_amount"] || "Early Termination fee"}</div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.RemainingCommitmentAmount)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>}

                        <div className="sim-pay-bill-see-details-content-row">
                          <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_taxable_amount"]}</div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.TaxableAmount)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>

                        <div className="sim-pay-bill-see-details-content-row">
                          <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_vat"]}{" "}{getVatPercentage() ? ` (${getVatPercentage()}%) ` : null}</div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.TaxAmount)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>

                        {(isHBB || invoice.PricePlanCode === "HBB") && Helpers.formatWithPORemoveCommas(invoice?.TotalInvoiceAmount) > 0 &&
                        <div className="sim-pay-bill-see-details-content-row">
                          <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_payment_bill_subtotal"] || "Subtotal"}</div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.TotalInvoiceAmount)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>}

                        <div className="sim-pay-bill-see-details-content-row">
                          <div className="sim-pay-bill-see-details-content-row-text-icon">
                            <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_recieved_pay"]}</div>
                            <img 
                              src={QuestionCircleIcon} alt=""
                              onClick={(e) => {
                                handleModalData(e, "received_payments_popup_json")}
                              }
                            />
                          </div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.ReceivedPayment)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>

                        <div className="sim-pay-bill-see-details-content-row">
                          <div className="sim-pay-bill-see-details-content-row-text-icon">
                            <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_previous_balance"]}{" "}<span>{translationKeys["stm_bill_payment_vat_inc"]}</span></div> 
                            <img 
                              src={QuestionCircleIcon} alt=""
                              onClick={(e) => {
                                handleModalData(e, "previous_balance_popup_json")}
                              }
                            />
                          </div>
                          <div>{Helpers.formatWithPORemoveCommas(invoice?.PreviousBalance)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>
                      </div> : ""}
                    </div>
                  </>}
                </div>
                : ""}
                {/* Collapsable Section Main Ends Here */}
              
                <div className="sim-deactivation-bill-sub-header">
                  <div>
                    <div>
                      {translationKeys["stm_bill_payment_total_due_amount"]}
                      <span>{translationKeys["stm_bill_payment_vat_inc"]}</span>
                    </div>
                    {Helpers.formatWithPORemoveCommas(invoice?.TotalDueAmount || 0)}{" "}{translationKeys["stm_general_currency"]}
                  </div>
                </div>
              
              </div>
              <img src={ZigZag} alt=""/>
            </div>
          
          </>
          : "" }
      </div>
    </div>

    return (<>
    {props.invoiceStatus === "loading" ?
    <SpinnerTimeLoader />
    : billContent
    }
    {openModal &&
      <ModalWrapper handleToggleModal={handleModal}>
        <ContentSlider
          imagesFolder={infoModalDetails?.imagesFolder}
          sliderData={infoModalDetails?.sliderData}
          closeModal={handleModal}
        />
      </ModalWrapper>
    }
    </>)
    // return null
}
export default BillInvoice;